import { matchPath } from 'react-router-dom';

import { SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { ROUTE_CAMPAIGN_AUTOAPPROVE, ROUTE_DONATION_PAGE_SETUP_PATH } from 'src/routes';

export const calculateSelectedItem = (pathname: string, items: SidebarModelResponse['MenuItems']) => {
  const loweredPathname = pathname.toLowerCase();

  /** ignore these routes */
  if (matchPath(loweredPathname, [ROUTE_DONATION_PAGE_SETUP_PATH, ROUTE_CAMPAIGN_AUTOAPPROVE])) {
    return null;
  }

  /** the different way for campaign and donation setup pages */
  const filterFn: (item: SidebarModelResponse['MenuItems'][0]) => boolean = loweredPathname.startsWith(
    '/campaigns/setup/'
  ) // new campaign url
    ? ({ Url }) => loweredPathname === Url.toLowerCase()
    : ({ Url }) => loweredPathname.startsWith(Url.toLowerCase());

  return items.filter(filterFn).sort((i1, i2) => i2.Url.length - i1.Url.length)[0]?.ID || null;
};
